var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWrap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M173.7 66.34C176.8 69.47 176.8 74.53 173.7 77.66L77.66 173.7C74.53 176.8 69.47 176.8 66.34 173.7C63.22 170.5 63.22 165.5 66.34 162.3L162.3 66.34C165.5 63.22 170.5 63.22 173.7 66.34V66.34zM109.7 269.7C106.5 272.8 101.5 272.8 98.34 269.7C95.22 266.5 95.22 261.5 98.34 258.3L258.3 98.34C261.5 95.22 266.5 95.22 269.7 98.34C272.8 101.5 272.8 106.5 269.7 109.7L109.7 269.7zM0 64C0 28.65 28.65 0 64 0H320C355.3 0 384 28.65 384 64V332.1C384 344.8 378.9 357.1 369.9 366.1L238.1 497.9C229.1 506.9 216.8 512 204.1 512H64C28.65 512 0 483.3 0 448V64zM320 16H64C37.49 16 16 37.49 16 64V448C16 474.5 37.49 496 64 496H204.1C205.4 496 206.7 495.9 208 495.8V376C208 353.9 225.9 336 248 336H367.8C367.9 334.7 368 333.4 368 332.1V64C368 37.49 346.5 16 320 16zM248 352C234.7 352 224 362.7 224 376V489.1C224.1 488.3 225.9 487.5 226.7 486.6L358.6 354.7C359.5 353.9 360.3 352.1 361.1 352H248z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrap);
export default __webpack_public_path__ + "static/media/wrap.98968330.svg";
export { ForwardRef as ReactComponent };